import type { components } from 'wg-api-sdk';

import ActionIcon from '@/features/analysis/components/AnalysisActions/ActionIcon';

import AdviceActions from './Actions/AdviceActions';

type Props = {
  advice: components['schemas']['OnesuranceAdvice'];
};

export default function GeneralAdvice({ advice }: Props) {
  const primaryAction = advice.actions?.find((action) => action.order === 1);

  return (
    <div className="bg-primary-50 dark:bg-primary-900 flex flex-col gap-1 rounded-lg p-2">
      <div className="flex items-center gap-1.5">
        <div className="text-primary-500">
          {primaryAction?.type && <ActionIcon type={primaryAction.type} />}
        </div>

        <p className="text-sm leading-tight">{advice.title}</p>
      </div>

      {advice.description && (
        <p className="text-muted-foreground text-xs">{advice.description}</p>
      )}

      <div className="mt-1">
        <AdviceActions actions={advice.actions ?? []} />
      </div>
    </div>
  );
}
